import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
interface ISummarySkeleton extends IContentLoaderProps {
  className?: string;
  line?: number;
}
const SummarySkeleton = (props: ISummarySkeleton) => {
  const { className = '', line = 3, ...restProps } = props;
  return line === 5 ? (
    <ContentLoader
      speed={2}
      width={'100%'}
      height={70}
      viewBox="0 0 100% 70"
      backgroundColor="#ECEEF3"
      foregroundColor="#DBDDE2"
      className={`${className}`}
      {...restProps}
    >
      <rect x="0" y="0" rx="3" ry="3" width="80" height="6" />
      <rect x="0" y="16" rx="3" ry="3" width="100%" height="6" />
      <rect x="0" y="32" rx="3" ry="3" width="100%" height="6" />
      <rect x="0" y="48" rx="3" ry="3" width="100%" height="6" />
      <rect x="0" y="64" rx="3" ry="3" width="180" height="6" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={2}
      width={'100%'}
      height={38}
      viewBox="0 0 100% 38"
      backgroundColor="#ECEEF3"
      foregroundColor="#DBDDE2"
      className={`${className}`}
      {...restProps}
    >
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="6" />
      <rect x="0" y="16" rx="3" ry="3" width="100%" height="6" />
      <rect x="0" y="32" rx="3" ry="3" width="180" height="6" />
    </ContentLoader>
  );
};

export default SummarySkeleton;
